import React, { Component } from 'react';

class FindMyBusActiveFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    toggleExpand = () => {
        this.setState(prev => ({ expanded: !prev.expanded }));
    };

    isActive(value) {
        if (value === false || value === null || value === undefined) return false;
        if (typeof value === 'number') return value > 0;
        if (typeof value === 'string') return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') return Object.keys(value).length > 0;
        return Boolean(value);
    }

    renderValue(key, value) {
        if (key === 'pax' && Array.isArray(value)) {
            return (
                <ul style={{ marginTop: 4 }}>
                    {value.map((pax, index) => {
                        const { type, minValue, maxValue } = pax;
                        return (
                            <li key={index}>
                                {type}: {minValue} – {maxValue != null ? maxValue : '∞'}
                            </li>
                        );
                    })}
                </ul>
            );
        }

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return <span>{String(value)}</span>;
        }

        if (Array.isArray(value) && value.length === 0) {
            return null;
        }

        return <span>{JSON.stringify(value)}</span>;
    }

    render() {
        const { activeFilter, t } = this.props;
        const { expanded } = this.state;

        return (
            <div style={{ fontFamily: 'sans-serif', lineHeight: 1.5 }}>
                <button
                    onClick={this.toggleExpand}
                    className="btn"
                    style={{ marginBottom: '1em', cursor: 'pointer' }}
                    aria-expanded={expanded}
                    aria-label={expanded ? 'Collapse filters' : 'Expand filters'}>
                    {t('find_my_bus.show_active_filter')}
                </button>

                {expanded && (
                    <ul style={{ listStyle: 'none', padding: 1, backgroundColor: '#ececec' }}>
                        {Object.entries(activeFilter)
                            .filter(([_, value]) => this.isActive(value))
                            .map(([key, value]) => (
                                <li key={key} style={{ marginBottom: '0.5em', marginLeft: 1 }}>
                                    <strong>{key}:</strong> {this.renderValue(key, value)}
                                </li>
                            ))}
                    </ul>
                )}
            </div>
        );
    }
}

export default FindMyBusActiveFilter;
